import UserProfile from "models/UserProfile";

const getProductVariant = (userProfile: UserProfile) => {
  const policy = userProfile.policy;

  if (policy.trip?.active) {
    return "Trip";
  } else if (policy.membership?.active) {
    return "Subscription";
  }
  return "";
};

const getProductTier = (userProfile: UserProfile) => {
  const policy = userProfile.policy;

  if (policy.hasCompleteCoverage) {
    return "Complete";
  } else if (policy.membership?.isEssential || policy.trip?.isEssential) {
    return "Essential";
  }
  return "";
};

export { getProductVariant, getProductTier };
